<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header mb-24" style="padding-top: 6px" type="flex" justify="space-between">

        <Col :xs="24" :sm="24" :md="24" :lg="0">
          <Row type="flex" :gutter="24">
            <!-- TEXT SEARCH -->
            <Col :xs="24" :sm="24" :md="24" :lg="0" class="mb-10">
              <Input
                class="search-input w-lg-100"
                placeholder="Введите номер документа или комментарий"
                v-model="searchString">
                <Icon type="ios-search" slot="suffix"/>
              </Input>
            </Col>

            <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
              <Select
                v-model="filter.type"

                clearable
                placeholder="Тип">
                <Option
                  v-for="(value, key) in order_type_labels"
                  :value="key"
                  :key="key">
                  {{ value }}
                </Option>
              </Select>
            </Col>


            <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
              <Select
                v-model="filter.applied"
                class="w-lg-100"
                clearable
                placeholder="Статус">
                <Option
                  v-for="item in filterOptions.applied"
                  :value="item.value"
                  :key="item.value">
                  {{ item.label }}
                </Option>
              </Select>
            </Col>
          </Row>
        </Col>


        <Col :xs="24" :sm="24" :md="24" :lg="0" class="mb-10">
          <DatePicker
            v-model="filterOrderDate"
            @on-change="changeFilterOrderDate"
            @on-clear="clearFilterOrderDate"
            format="dd.MM.yyyy"
            type="daterange"
            :start-date="currentDate"
            placeholder="Дата документа"
            class="w-lg-100"
          ></DatePicker
          >
        </Col>


        <!--&lt;!&ndash; CREATE &ndash;&gt;-->
        <!--<Col span="5">-->
        <!--&lt;!&ndash;&lt;!&ndash; CREATE &ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;<Button&ndash;&gt;-->
        <!--&lt;!&ndash;type="success"&ndash;&gt;-->
        <!--&lt;!&ndash;class="ls_create_right_button"&ndash;&gt;-->
        <!--&lt;!&ndash;:to="{ name: item_type + '_create' }"&ndash;&gt;-->
        <!--&lt;!&ndash;&gt;Создать&ndash;&gt;-->
        <!--&lt;!&ndash;</Button>&ndash;&gt;-->
        <!--</Col>-->
      </Row>

      <Row class="mb-15">
        <Button v-if="showClearFilter" @click="clearFilter" type="error"
        >Сбросить фильтр
        </Button>
      </Row>

    </div>

    <!-- DATA TABLE + PAGINATION -->
    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>


    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <router-link :to="'pdocs/detail/' + item.id" v-for="item in data" class="card-container">
        <div>
          <h2>{{ item.name }}</h2>

          <p v-if="item.applied === true" class="ivu-tag-success ivu-tag" style="padding: 0">
            <span class="ivu-tag-text ivu-tag-color-white">Статус: Проведен</span>
          </p>
          <p v-else class="ivu-tag-warning ivu-tag" style="padding: 0">
            <span class="ivu-tag-text ivu-tag-color-white">Статус: Не проведен</span>
          </p>

          <p>Дата документа: {{ formatDateTime(item.order_date) }}</p>
          <p>Кол-во позиций: {{ item.items_count }}</p>
          <p>Отправитель: {{ item.sender.name }}</p>
          <p>Получатель: {{ item.recipient.name }}</p>
          <p>Пользователь: {{ item.created_by }}</p>
        </div>

        <div>
          <p class="price">{{ formatNumber(item.total_sum) }} {{ currency }}</p>
        </div>

      </router-link>
    </div>


    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15, 25, 35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <productOrderItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></productOrderItem>


    <drawersCommon :item="drawerItem"></drawersCommon>


  </div>
</template>
<script>
    import {base_url} from "../../http.js";
    import {BaseTableData} from "../../base/base_table.js";

    import {order_type_labels} from "./order_type_list.js"
    import productOrderItem from "@/apps/product_order/productOrderItem.vue";
    import drawersCommon from "@/apps/partial/drawers.vue";


    import {
        TYPE_SELL,
        TYPE_DEBT_SELL,
        TYPE_PURCHASE,
        TYPE_RETURN_SELL,
        TYPE_RETURN_PURCHASE,
        TYPE_CHANGES_IN,
        TYPE_CHANGES_OUT,
        TYPE_MOVING,
        TYPE_CHANGES_INVENTORY
    } from "./const.js";
    import {getSenderRecipientTypeLabel, getRouteNameBySenderRecipientType} from "./func";

    let _app = BaseTableData();

    _app.name = "productOrder";
    _app.props = {
        default_type: {
            type: String,
            default: ""
        },
    };
    _app.components = {
        productOrderItem,
        drawersCommon

    };

    _app.data = function () {
        return {
            // DISPLAY_TOTAL_DISCOUNT: ['sell'],

            // Base settings
            baseViewUrl: base_url + "/product_orders/",
            item_type: "product_order",
            loading: true,

            drawerItem: {
                show: false,
                id: null,
                type: null
            },

            // Table settings
            columns: [
                // {
                //   type: "selection",
                //   width: 60,
                //   align: "center"
                // },
                {
                    title: "Документ",
                    maxWidth: 400,
                    key: "name",
                    // sortable: true,
                    render: (h, params) => {
                        return h(
                            "router-link",
                            {
                                props: {
                                    to: {
                                        name: this.item_type + "_detail",
                                        params: {id: params.row.id}
                                    }
                                }
                            },
                            params.row.name
                        );
                    }
                },
                {
                    title: "Статус",
                    // width: 340,
                    align: "center",
                    key: "applied",
                    render: (h, params) => {
                        // console.log(params.row);
                        if (params.row.applied) {
                            return h(
                                "tag",
                                {
                                    props: {
                                        color: "success"
                                    },
                                    style: {
                                        backgroundColor: "#ffffff",
                                        color: "#25D77E",
                                        fontSize: "15px",
                                        borderRadius: "20px"
                                    },
                                },
                                "Проведен"
                            );
                        } else {
                            return h(
                                "tag",
                                {
                                    props: {
                                        color: "warning"
                                    },
                                    style: {
                                        backgroundColor: "#ffffff",
                                        color: "#ED4729",
                                        fontSize: "15px",
                                        borderRadius: "20px"
                                    },
                                },
                                "Не проведен"
                            );
                        }
                    }
                },
                {
                    title: "Дата документа",
                    // width: 80,
                    align: "center",
                    // key: "order_date_display",
                    // sortable: true,
                    render: (h, params) => {
                        return h("span", {}, this.formatDateTime(params.row.order_date));
                    }
                },
                {
                    title: "Сумма",
                    width: 110,
                    key: "total_sum",
                    align: "center",
                    sortable: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {},
                            this.formatNumber(params.row.total_sum) + " " + this.currency
                        );
                    }
                },
                {
                    title: "Кол-во позиций",
                    maxWidth: 90,
                    key: 'items_count',
                    align: "center",
                    // sortable: true,
                },
                {
                    title: "Отправитель",

                    render: (h, params) => {
                        let sender_type_label = getSenderRecipientTypeLabel(params.row.sender.type);

                        return h("div", {}, [
                            h(
                                "div",
                                {style: {fontSize: "11px", color: "grey"}},
                                sender_type_label.toLowerCase()
                            ),

                            h("div", {
                                    on: {
                                        click: () => {
                                            this.showDrawer(params.row.sender);
                                        }
                                    },
                                    style: {
                                        cursor: 'pointer'
                                    }
                                },
                                params.row.sender.name
                            )

                        ]);
                    }
                },
                {
                    title: "Получатель",
                    // width: 80,
                    // key: "recipient['name']",
                    // align: "right",
                    // sortable: true,
                    render: (h, params) => {
                        let recipient_type_label = getSenderRecipientTypeLabel(params.row.recipient.type);

                        return h("div", {}, [
                            h(
                                "div",
                                {style: {fontSize: "11px", color: "grey"}},
                                recipient_type_label.toLowerCase()
                            ),
                            h("div", {
                                    on: {
                                        click: () => {
                                            this.showDrawer(params.row.recipient);
                                        }
                                    },
                                    style: {
                                        cursor: 'pointer'
                                    }
                                },
                                params.row.recipient.name
                            )
                        ]);
                    }
                },
                {
                    title: "Пользователь",
                    maxWidth: 180,
                    align: "center",
                    key: "created_by",
                },
                {
                    title: "Действия",
                    // key: 'action',
                    width: 120,
                    align: "center",
                    render: (h, params) => {
                        let route_name = `${this.item_type}_edit`;
                        if (params.row.type === "changes_in") {
                            route_name = "product_order_change_in_edit";
                        } else if (params.row.type === "changes_out") {
                            route_name = "product_order_change_out_edit";
                        } else if (params.row.type === "moving") {
                            route_name = "product_order_change_moving_edit";
                        } else if (params.row.type === TYPE_CHANGES_INVENTORY) {
                            route_name = "product_order_inventory_edit";
                        }

                        let buttons = [];

                        if (this.display_edit_button_by_row(params.row)) {
                            buttons.push(
                                h(
                                    "Tooltip",
                                    {
                                        props: {
                                            content: "Редактировать"
                                        }
                                    },
                                    [
                                        h("Button", {
                                            props: {
                                                to: {
                                                    name: route_name,
                                                    params: {id: params.row.id}
                                                },
                                                type: "primary",
                                                size: "small",
                                                // icon: 'ios-information-circle-outline',
                                                icon: "md-create",
                                            },
                                            style: {
                                                display: "inline-block",
                                                boxShadow: "none",
                                                background: "transparent",
                                                border: "none",
                                                color: "#DEDEDE",
                                            }
                                        })
                                    ]
                                )
                            );
                        }

                        if (this.display_delete_button_by_row(params.row)) {

                            buttons.push(
                                h(
                                    "Tooltip",
                                    {
                                        props: {
                                            content: "Удалить"
                                        }
                                    },
                                    [
                                        h("Button", {
                                            props: {
                                                size: "small",
                                                icon: "md-trash",
                                            },
                                            style: {
                                                display: "inline-block",
                                                boxShadow: "none",
                                                background: "transparent",
                                                border: "none",
                                                color: "#DEDEDE",
                                            },
                                            on: {
                                                click: () => {
                                                    this.deleteItem(params.row.id);
                                                }
                                            }
                                        })
                                    ]
                                )
                            );
                        }

                        return h("div", buttons);
                    }
                }
            ],
            data: [],
            lastDraw: 0,
            totalRecords: null,
            currentPage: 1,
            pageSize: 15,
            sorting: "",
            searchString: "",
            // showClearFilter: false,

            filterShow: false,
            filter: {
                type: "",
                applied: "",
                order_date__gt: "",
                order_date__lt: ""
            },
            filterOptions: {
                // type: [
                //   {
                //     value: TYPE_SELL,
                //     label: "Продажа"
                //   },
                //   {
                //     value: TYPE_PURCHASE,
                //     label: "Закупка"
                //   },
                //   {
                //     value: TYPE_RETURN_SELL,
                //     label: "Возврат продажи"
                //   },
                //   {
                //     value: TYPE_RETURN_PURCHASE,
                //     label: "Возврат закупки"
                //   },
                //   {
                //     value: TYPE_CHANGES_INVENTORY,
                //     label: "Инвентаризация"
                //   },
                //   {
                //     value: TYPE_CHANGES_IN,
                //     label: "Оприходование"
                //   },
                //   {
                //     value: TYPE_CHANGES_OUT,
                //     label: "Списание"
                //   },
                //   {
                //     value: TYPE_MOVING,
                //     label: "Перемещение"
                //   }
                // ],
                applied: [
                    {
                        value: "true",
                        label: "Проведен"
                    },
                    {
                        value: "false",
                        label: "Не проведен"
                    }
                ]
            },

            filterOrderDate: ["", ""],
            selected: [],

            item: {
                show: false,
                id: null,
                action: null
            }
        };
    };

    _app.computed.currency = function () {
        return this.$store.state.currency;
    };
    _app.computed.order_type_labels = function () {
        return order_type_labels
    };

    _app.computed.currentDate = function () {
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        return date;
    };


    // _app.methods.getSenderTypeLabel = function(senderType) {
    //   return getSenderTypeLabel(senderType);
    // };

    // Переключения режима "Доп.фильтр"
    _app.methods.toogleFilter = function (val) {
        this.filterShow = val;

        // Если убираем фильтр - очищаем все поля фильтра
        if (!val) {
            for (let key in this.filter) {
                this.filter[key] = "";
            }

            // Дополнительная очистка фильтров (Даты документа)
            this.filterOrderDate = [];
        }
    };

    // Очистка фильтров
    _app.methods.clearFilter = function (val) {
        // Очистка общих фильтров и посика
        if (this.searchString) {
            this.searchString = "";
        }
        for (let key in this.filter) {
            if (this.filter[key]) {
                this.filter[key] = "";
            }
        }

        // Дополнительная очистка фильтров (Даты документа)
        this.filterOrderDate = [];
    };

    _app.methods.changeFilterOrderDate = function (date_arr, date_obj) {
        if (date_arr[0] && date_arr[1]) {
            this.filter.order_date__gt = this.filterOrderDate[0];
            this.filter.order_date__lt = this.filterOrderDate[1];

            // this.filter.order_date__gt = date_arr[0] + 'T00:00:00';
            // this.filter.order_date__lt = date_arr[1] + 'T00:00:00';
        }
    };

    // Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
    _app.methods.clearFilterOrderDate = function (date_arr, date_obj) {
        this.filter.order_date__gt = "";
        this.filter.order_date__lt = "";
    };

    //Открыть модальое окно и передать данные
    _app.methods.showDrawer = function(item) {
        this.drawerItem.id = item.id;
        this.drawerItem.type = item.type;
        this.drawerItem.show = true;
    };



    _app.created = function () {


        // if (this.default_type) {
        if (this.default_type === TYPE_CHANGES_IN) {
            this.filter.type = TYPE_CHANGES_IN;
        } else if (this.default_type === TYPE_CHANGES_OUT) {
            this.filter.type = TYPE_CHANGES_OUT;
        } else if (this.default_type === TYPE_MOVING) {
            this.filter.type = TYPE_MOVING;
        } else if (this.default_type === TYPE_CHANGES_INVENTORY) {
            this.filter.type = TYPE_CHANGES_INVENTORY;
        }

        // }

    };
    export default _app;
</script>

<style scoped>

  .ivu-select {
    min-width: 120px;
  }

  .search-input {
    width: 400px;
  }

  @media screen and (max-width: 1900px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 1500px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 991px) {
    .w-lg-100 {
      width: 100%;
    }

    .search-input {
      width: 100%;
    }

    .ivu-date-picker input {
      max-width: 100%;
      width: 100%;
    }
  }
</style>


<style>
  @media (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }

  }
</style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrder.vue